import { isMobile } from '@/utils';
import Tracker from './tracker';

class OrderTracker extends Tracker {
  /*
   *
   * @desc: 订单创建页面埋点
   * @param {string} action 事件操作
   *
   */
  orderConfirmPage = ({ category = '', action, eventLabel = '', value: _value }) => {
    let label = eventLabel;
    let value = _value || 1;
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_${category ? category : 'orderConfirm_page'}`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 订单页面埋点
   * @param {string} action 事件操作
   *
   */
  orderDetailPage = ({ action, label: _label }) => {
    let label = _label ?? '';
    let value = 1;
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_orderDetail_page`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * @description 订单列表页埋点
   *
   */
  orderListPage = ({ action, label: _label }) => {
    let label = _label ?? '';
    let value = 1;
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_myorder`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * @description 结账contactInfo信息埋点
   *
   */
  orderContactInfo = ({ action, label: _label }) => {
    let label = _label ?? '';
    let value = 1;
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_contact_info`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * 结账结果页埋点
   * @param result success
   */
  orderResultPage = ({ result, action, label: _label }) => {
    let label = _label ?? '';
    let value = 1;

    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}${result === 'success' ? `_order_success` : ''}`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 订单详情页面视频教程埋点
   * @param {string} action 事件操作
   * @param {string} label 事件操作
   * @param {string} value 事件操作
   *
   */
  tutorial = ({ action, label = '', value }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_order_detail_page`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /*
   *
   * @desc: 订单详情页面视FAQ埋点
   * @param {string} action 事件操作
   * @param {string} label 事件操作
   * @param {string} value 事件操作
   *
   */
  faq = ({ action, label = '', value }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_order_detail_page`,
        action,
        label,
        value,
      });
    } catch (e) {
      console.log(e);
    }
  };
}

const T = new OrderTracker();
export default T;
